<a
	class="card-block copo-clickable"
	mat-ripple
	[routerLink]="['/order-tracking/order/card', order.supplierOrderNumber, order.supplierOrderItemNumber]">
	<div class="order-tracking-list-card-header">
		<span class="order-tracking-list-card-header-title">{{ getOrderName(order) }}</span>
		<span class="order-product-description">{{ order.productDescription ? order.productDescription : UNDERSCORE  }}</span>
		<span class="order-tracking-list-card-header-ton">{{ getQuantity(order, 'ordered') | copoNumber:'weight':'t' }}</span>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>{{ getProductLabel() }}</span>
			<span class="order-card-value">{{ getProductName(order) }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>order-tracking.dimension</span>
			<span class="order-card-value">{{ order | copoDimension }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>order-tracking.cdd</span>
			<span class="order-card-value">{{ checkCddWeekData() }}</span>
		</div>
	</div>
	<table class="order-tracking-list-card-information-icons-table">
		<thead>
			<tr>
				<th>
					<div class="order-tracking-list-card-information-icon-border">
						<mat-icon class="order-tracking-list-card-information-icon" svgIcon="in_production"></mat-icon>
					</div>
				</th>
				<th>
					<div class="order-tracking-list-card-information-icon-border">
						<mat-icon class="order-tracking-list-card-information-icon" svgIcon="in_stock"></mat-icon>
					</div>
				</th>
				<th>
					<div class="order-tracking-list-card-information-icon-border">
						<mat-icon class="order-tracking-list-card-information-icon" svgIcon="in_transit"></mat-icon>
					</div>
				</th>
				<th>
					<div class="order-tracking-list-card-information-icon-border">
						<mat-icon class="order-tracking-list-card-information-icon" svgIcon="delivered"></mat-icon>
					</div>
				</th>
			</tr>
			<tr>
				<th translate>order-tracking.in.production</th>
				<th translate>order-tracking.in.stock</th>
				<th translate>order-tracking.in.transit</th>
				<th translate>order-tracking.delivered</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ getQuantity(order, 'inProduction') | copoNumber:'weight':'t' }}</td>
				<td>{{ getQuantity(order, 'readyToShip') | copoNumber:'weight':'t' }}</td>
				<td>{{ getQuantity(order, 'inTransit') | copoNumber:'weight':'t' }}</td>
				<td>{{ getQuantity(order, 'delivered') | copoNumber:'weight':'t' }}</td>
			</tr>
		</tbody>
	</table>
</a>
